import { Dispatch, SetStateAction } from 'react';
import { handleTrack } from '../../utils/tracker';
import { Button, ButtonVariants } from '../Atoms/Button';
import { If } from '../Atoms/Conditionals';
import { scrollIntoView } from '../Common/navigation/utils';
import { useWindowDimensions } from '../hooks/use-window-dimension';
import { usePaytaxCalcContext } from './context';
import { TabSwitch } from './switching';
import { CALCULATOR_DATA, SHOW_CALCULATION, tabsData } from './types';
interface tabsSwitchData {
  tabsData: tabsData;
  defaultActiveTab: number;
  selectedFinancialYear?: string;
  commonProps: {
    hasError: boolean;
    setGlobalError: Dispatch<SetStateAction<boolean>>;
    inputTabData: CALCULATOR_DATA;
    setInputData: Dispatch<SetStateAction<CALCULATOR_DATA>>;
    showCalculation: SHOW_CALCULATION;
    setShowCalculation: Dispatch<SetStateAction<SHOW_CALCULATION>>;
    taxWrapper: HTMLDivElement | null;
  };
  activeTab: number;
  setActiveTab: Dispatch<SetStateAction<number>>;
  showSlabsTable?: boolean;
}

const TabComponent = ({
  tabsData,
  commonProps,
  selectedFinancialYear,
  activeTab,
  setActiveTab,
  showSlabsTable,
}: tabsSwitchData) => {
  const { financialYear, setFinancialYearCalc } = usePaytaxCalcContext();

  const noOfTabs = tabsData.tabs.length;
  const button = tabsData.tabStyles.isButton;
  const handleBack = () => {
    setActiveTab((prev: number) => {
      return prev === 0 ? noOfTabs - 1 : prev - 1;
    });
  };
  const { width } = useWindowDimensions();
  const handleNext = async () => {
    if (activeTab === noOfTabs - 1) {
      handleTrack({ label: `Calculate_Tax}` });
      setActiveTab((prev) => (prev + 1) % noOfTabs);
      if (commonProps.taxWrapper) {
        if (width < 768) scrollIntoView(commonProps.taxWrapper, 700);
        else scrollIntoView(commonProps.taxWrapper, 70);
      }
      if (selectedFinancialYear) setFinancialYearCalc(financialYear);
      commonProps.setShowCalculation({
        displayCalculation: true,
        renderCalculation: !commonProps.showCalculation?.renderCalculation,
      });
    } else {
      setActiveTab((prev) => prev + 1);
    }
  };

  return (
    <>
      <TabSwitch
        tabsData={tabsData}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        commonProps={commonProps}
        showSlabsTable={showSlabsTable}
      />
      <If condition={button}>
        <div className="flex justify-end">
          <Button
            className={`${
              activeTab === 0 ? 'hidden' : ''
            } text-base py-3 sm:mt-4  w-32 text-blue-350 bg-white sm:w-full focus:outline-none`}
            onClick={handleBack}
          >
            Back
          </Button>
          <Button
            variant={ButtonVariants.bluebordered}
            className="text-base font-bold py-[10px] mt-1 px-[60px] rounded-md sm:rounded-md sm:mt-4 sm:w-full"
            onClick={handleNext}
          >
            {activeTab === noOfTabs - 1 ? 'View Calculation' : 'Continue'}
          </Button>
        </div>
      </If>
    </>
  );
};

export default TabComponent;
